// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__Evbmz","content":"profile_content__behti","logoutBtn":"profile_logoutBtn__Chavp"};